import { Style } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Text } from '@app/components/core/typography/Text'

export type IconListItem = {
  icon: IconProp
  text: string
}

export type IconListProps = {
  items: IconListItem[]
  style?: Style
}

export const IconList = ({ items, style }: IconListProps) => {
  return (
    <Column gap="1rem" alignItems="stretch" style={style}>
      {items.map((item, index) => (
        <Row key={`${item.text}-${index}`} style={{ alignItems: 'center' }}>
          <FontAwesomeIcon
            icon={item.icon}
            style={{
              color: 'var(--shades-blue-500)',
              height: '1.125rem',
              width: '1.125rem',
              flexShrink: 0,
            }}
          />
          <Text.Medium style={{ color: 'var(--shades-blue-600)' }}>
            {item.text}
          </Text.Medium>
        </Row>
      ))}
    </Column>
  )
}
